<template>
  <StudioMultiSelect
    v-model="selectedStatus"
    :items="status"
    :label="label"
    :placeholder="placeholder"
    @clearClick="$emit('clearInfo', label)"
  >
    <template v-slot:selection="{item, index}">
      <span
        v-if="index === 0 && selectedStatus.length === status.length"
        class="repliers-status-filter__placeholder"
      >
        {{ placeholder }}
      </span>
      <template
        v-else-if="selectedStatus.length !== status.length"
      >
        <v-chip
          v-if="index < minimumFilterView"
          small
        >
          <span>{{ getText(item) }}</span>
        </v-chip>
        <span
          v-if="index === minimumFilterView"
          class="grey--text caption"
        >
          (+{{ selectedStatus.length - minimumFilterView }} {{ message }})
        </span>
      </template>
    </template>
  </StudioMultiSelect>
</template>

<script>
import StudioMultiSelect from '@/components/filter/models/StudioMultiSelect';
import repliersModel from '@/mixins/repliers-model';

export default {
  name: 'ReplierStatusFilter',
  components: {
    StudioMultiSelect,
  },
  mixins: [
    repliersModel,
  ],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      default: 'Status',
    },
    placeholder: {
      type: String,
      default: 'Todos',
    },
  },
  data() {
    return {
      minimumFilterView: 1,
    };
  },
  computed: {
    statusLabel() {
      return this.$t('components.StatusTable.status');
    },
    status() {
      return [
        {
          text: this.$t('components.StatusTable.onlineText'),
          value: 'ONLINE',
        },
        {
          text: this.$t('components.StatusTable.offlineText'),
          value: 'OFFLINE',
        },
      ];
    },
    message() {
      return this.selectedStatus.length - this.minimumFilterView === 1 ? 'outro' : 'outros';
    },
    selectedStatus: {
      get() {
        // When select all options, we filter data with repliers and without repliers
        // (sending nothing, but show as all selected)
        if (!this.value) {
          return [...this.status];
        }

        const value = this.value && this.value.value;

        // When selection is empty, we filter data without replier
        // (sending empty array and show nothing select)
        if (value && value.length === 0) {
          return [];
        }

        return value;
      },
      set(newValue) {
        // When selection is empty, we filter data without replier
        // (sending empty array and show nothing select)
        if (newValue && newValue.length === 0) {
          return this.$emit('input', {
            value: [],
          });
        }

        // When select all options, we filter data with repliers and without repliers
        // (sending nothing, but show as all selected)
        if (newValue.length === this.status.length) {
          return this.$emit('input', undefined);
        }

        // When select some options, we filter data only with the selected repliers
        this.$emit('input', {
          value: newValue.map(v => v),
        });
      },
    },
  },
  methods: {
    getText(item) {
      return typeof item === 'object' ? item.text : item;
    },
  },
};
</script>

<style scoped lang="scss">
  .v-select__selection.v-select__selection--comma {
    line-height: 120%;
  }

  .repliers-status-filter__placeholder {
    font-size: 14px;
    color: #919191;
  }

  ::v-deep {
    input {
      font-size: 14px;
    }
  }
</style>
